export function accordion() {
    const accordionBlock = $(".accordion");
    accordionBlock.on("click", ".heading", function (e) {
        let accordion = $(this).parents(".accordion");
        let parent = $(this).parent();
        if (parent.hasClass("opened")) {
            parent.find(".hidden-info").slideUp();
            setTimeout(() => {
                parent.removeClass("opened");
            }, 400);
        } else {
            setTimeout(() => {
                accordion.find(".accordion-item").removeClass("opened");
                parent.addClass("opened");
            }, 400);
            accordion.find(".accordion-item").find(".hidden-info").slideUp();
            parent.find(".hidden-info").slideDown();
        }
        e.preventDefault();
    });

    accordionBlock.each(function () {
        $(this).find(".accordion-item:first-child").addClass("opened");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/accordion.js